// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/dist/cjs.js??ref--4-oneOf-1-1!../../node_modules/@nuxt/postcss8/node_modules/postcss-loader/dist/cjs.js??ref--4-oneOf-1-2!./tailwind.css");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("54e80372", content, true, {"sourceMap":false});